export const formatBundleId = (id: string) =>
  id.includes('fast-bundle') ? 'fast-bundle' : id;
